import { useAuth } from '../store/auth-context';
import { useMeSpaces } from './useMeSpaces';
import { resolveDefaultSpaceId } from '../lib/default-space';

/**
 * The spaceId the org-admin UI uses as a URL anchor when calling the
 * space-scoped CRUD routes for org-scoped integrations. The deployed API
 * has no dedicated org-scoped single-resource routes — every read / mutate
 * goes through `/api/v1/spaces/{spaceId}/conn/integrations/{integrationId}`
 * even when the integration itself isn't owned by the space. The URL
 * spaceId is effectively an authz gate (admin must be a member); the
 * integration lookup happens by id.
 *
 * Resolution mirrors `ConsoleLayout`'s fallback: last-visited → personal →
 * first. Returns `undefined` while spaces are loading so callers can gate
 * mutations behind it.
 */
export function useAnchorSpaceId(): string | undefined {
  const { user } = useAuth();
  const { data: spacesData } = useMeSpaces();
  return resolveDefaultSpaceId({
    spaces: spacesData?.items ?? [],
    lastSpaceId: user?.preferences?.lastSpaceId,
    defaultSpaceId: user?.defaultSpaceId,
  });
}
